export default __webpack_public_path__ + "static/media/pro-player.438d0f66.png";